module.exports = __webpack_public_path__ + "img/icon-energy-produced.4b1071f5.svg";